<div class="modal">
  <div id="header">
    <div class="header-row">
      <div class="title">
        <mat-icon fontSet="material-icons-round" class="close">post_add</mat-icon>
        <span class="kbody-huge">Course Request Details</span>
      </div>
      <mat-icon fontSet="material-icons-round" class="close" (click)="closeModal()">close</mat-icon>
    </div>
    <div class="admin-button-row" *ngIf="!isLoading && getCourseItemId()">
      <div class="btn" (click)="openUploadDocumentsModal()">
        <mat-icon fontSet="material-icons-round" class="icon">upload</mat-icon>
        <span class="kbody-medium">Upload Docs</span>
      </div>
    </div>
  </div>
  <div class="modal-content">
    <app-loading-spinner class="spinner" *ngIf="isLoading"></app-loading-spinner>
    <app-course-request-review 
      [showStatusRow]="true" 
      [enableDocumentUpload]="false"
      *ngIf="!isLoading" 
      [course]="course"
      (documentsUploaded)="onDocumentsUploaded()">
    </app-course-request-review>
  </div>
  <div class="button-row" [ngClass]="{'flex-end': course.currentCatalogStatusKid !== 'SPECIAL_REQUEST_PENDING'}">
    <app-button *ngIf="course.currentCatalogStatusKid === 'SPECIAL_REQUEST_PENDING'" [text]="'Deny Request'" [class]="'red'" [icon]="{materialIcon: 'do_disturb_alt'}" (click)="closeModal('deny')"></app-button>
    <div class="actions">
      <app-button [text]="'Cancel'" [class]="'white'" (click)="closeModal()"></app-button>
      <app-button *ngIf="course.currentCatalogStatusKid === 'SPECIAL_REQUEST_PENDING'" [text]="'Approve Request'" [icon]="{materialIcon: 'check'}" (click)="closeModal('approve')" ></app-button>
      <app-button *ngIf="course.currentCatalogStatusKid === 'SPECIAL_REQUEST_APPROVED'" [class]="'grey'" [text]="'Submit as Catalog Suggestion'"></app-button>
      <!-- TODO: Add this Redo Approval button back in when backend functionality is ready -->
      <!-- <app-button *ngIf="course.currentCatalogStatusKid === 'SPECIAL_REQUEST_DENIED'" [class]="'grey'" [text]="'Redo Approval Process'"></app-button> -->
    </div>
  </div>
  <ng-container *ngIf="!isLoading && showUploadDocumentsModal && getCourseItemId()">
    <app-upload-course-documents 
      [courseItemId]="getCourseItemId()"
      (closeModal)="closeUploadDocumentsModal()"
      (documentsUploaded)="onDocumentsUploaded()">
    </app-upload-course-documents>
  </ng-container>
</div>
